/**
 * IMPORTS
 */

import type { IExcluirUsuarioClienteResponseApi } from "@/data/dtos/response-api/usuarios-cliente/excluir-usuario-cliente-response-api";
import { axiosClient } from "@/data/http/axios/axios-client";
// typings
import type { IExcluirUsuarioClienteRepository } from "@/domain/repositories/usuarios-cliente/excluir-usuario-cliente-repository-contract";

/**
 * Implementação HTTP — `DELETE usuarios-cliente/{id}`.
 */
class ExcluirUsuarioClienteRepositoryImplementation implements IExcluirUsuarioClienteRepository {
  async delete(user_id: number): Promise<IExcluirUsuarioClienteResponseApi> {
    const response = await axiosClient<IExcluirUsuarioClienteResponseApi>(
      `usuarios-cliente/${user_id}`,
      {
        method: "delete",
      }
    );

    return response;
  }
}

/**
 * EXPORT
 */
export { ExcluirUsuarioClienteRepositoryImplementation };
